import { render } from "./VerticalBar.vue?vue&type=template&id=d6b5b2f8&scoped=true"
import script from "./VerticalBar.vue?vue&type=script&lang=js"
export * from "./VerticalBar.vue?vue&type=script&lang=js"

import "./VerticalBar.vue?vue&type=style&index=0&id=d6b5b2f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lrive\\source\\repos\\XOneFrameworkWEB\\XOneWebVue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b5b2f8"]])

export default __exports__